/* this file is transformed by vux-loader */
/* eslint-disable */
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.constructor.js";
import "core-js/modules/es.regexp.dot-all.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.sticky.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.string.replace.js";
import { buildConfig } from '@/api/login';
import Vue from 'vue';

// 公共方法，工具函数
export default {
  // 微信ticket授权
  wxTkt: function wxTkt(callback) {
    var that = this;
    var url = window.location.href.split('#')[0];
    var param = {
      url: url
    };
    // 判断是否是ios wkwebview内核微信浏览器
    // if (window.__wxjs_is_wkwebview === true) {
    //   const vs = utils.getUrlParams('vs')
    //   if (vs === null || typeof vs === 'undefined') {
    //   }
    // }
    buildConfig(param).then(function (res) {
      // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
      // data.debug = true;
      Vue.wechat.config(res);
      Vue.wechat.ready(function () {
        callback();
      });
      Vue.wechat.error(function (res) {
        // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
        if (res.errMsg === 'config:invalid signature') {
          alert('error');
          that.wxTkt(callback);
        }
      });
    }).catch(function (res) {
      alert('微信授权失败！');
      console.log(res);
    });
  },
  // 获取昨天，今天，明天，后天，返回格式2017-08-11
  getDateStr1: function getDateStr1(AddDayCount) {
    var dd = new Date();
    dd.setDate(dd.getDate() + AddDayCount); // 获取AddDayCount天后的日期
    var m = dd.getMonth() + 1; // 获取当前月份的日期
    var d = dd.getDate();
    m = m > 9 ? m : '0' + m;
    d = d > 9 ? d : '0' + d;
    return m + '月' + d + '日';
  },
  // 获取昨天，今天，明天，后天，返回格式2017-08-11
  getDateStr2: function getDateStr2(AddDayCount) {
    var dd = new Date();
    dd.setDate(dd.getDate() + AddDayCount); // 获取AddDayCount天后的日期
    var y = dd.getFullYear();
    var m = dd.getMonth() + 1; // 获取当前月份的日期
    var d = dd.getDate();
    m = m > 9 ? m : '0' + m;
    d = d > 9 ? d : '0' + d;
    return y + '-' + m + '-' + d;
  },
  // 获取昨天，今天，明天，后天，返回格式2017-08-11 12:30
  formatDate: function formatDate(timeStr, fmt) {
    var date = new Date();
    date.prototype.format = function (fmt) {
      var o = {
        'M+': this.getMonth() + 1,
        // 月份
        'd+': this.getDate(),
        // 日
        'h+': this.getHours(),
        // 小时
        'm+': this.getMinutes(),
        // 分
        's+': this.getSeconds(),
        // 秒
        'q+': Math.floor((this.getMonth() + 3) / 3),
        // 季度
        'S': this.getMilliseconds() // 毫秒
      };
      if (/(y+)/.test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length));
      }
      for (var k in o) {
        if (new RegExp('(' + k + ')').test(fmt)) {
          fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
        }
      }
      return fmt;
    };
    return new Date(timeStr).format('yyyy-MM-dd hh:mm:ss');
  },
  // 获取星期，返回“周几”
  getWeekStr: function getWeekStr(AddDayCount) {
    var week = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];
    var dd = new Date();
    dd.setDate(dd.getDate() + AddDayCount); // 获取AddDayCount天后的日期
    var w = dd.getDay();
    return week[w];
  },
  getNowDate: function getNowDate() {
    var now = new Date();
    var date = '';
    var y = now.getFullYear();
    var m = now.getMonth() + 1;
    var d = now.getDate();
    var nouce = Math.floor(Math.random() * 10000);
    m = m > 9 ? m : '0' + m;
    d = d > 9 ? d : '0' + d;
    date = y.toString() + m.toString() + d.toString() + nouce.toString();
    return date;
  },
  // 获取地址栏参数
  getUrlParams: function getUrlParams(name) {
    var _t = window.location.href.split('?');
    if (_t.length > 1) {
      var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
      var r = _t[1].match(reg);
      if (r != null) return unescape(r[2]);
      return '';
    }
    return '';
  },
  // 设置微信title
  setWechatTitle: function setWechatTitle(title) {
    document.title = title;
    var mobile = navigator.userAgent.toLowerCase();
    if (/iphone|ipad|ipod/.test(mobile)) {
      var iframe = document.createElement('iframe');
      iframe.style.display = 'none';
      // 替换成站标favicon路径或者任意存在的较小的图片即可
      iframe.setAttribute('src', '/favicon.ico');
      var _iframeCallback = function iframeCallback() {
        setTimeout(function () {
          iframe.removeEventListener('load', _iframeCallback);
          document.body.removeChild(iframe);
        }, 0);
      };
      iframe.addEventListener('load', _iframeCallback);
      document.body.appendChild(iframe);
    }
  },
  addUrlPara: function addUrlPara(name, value) {
    var currentUrl = window.location.href.split('#')[0];
    if (/\?/g.test(currentUrl)) {
      if (/name=[-\w]{4,25}/g.test(currentUrl)) {
        currentUrl = currentUrl.replace(/name=[-\w]{4,25}/g, name + '=' + value);
      } else {
        currentUrl += '&' + name + '=' + value;
      }
    } else {
      currentUrl += '?' + name + '=' + value;
    }
    if (window.location.href.split('#')[1]) {
      return currentUrl + '#' + window.location.href.split('#')[1];
    } else {
      return currentUrl;
    }
  },
  addUrlPara2: function addUrlPara2(url, name, value) {
    var currentUrl = url.split('#')[0];
    if (/\?/g.test(currentUrl)) {
      if (/name=[-\w]{4,25}/g.test(currentUrl)) {
        currentUrl = currentUrl.replace(/name=[-\w]{4,25}/g, name + '=' + value);
      } else {
        currentUrl += '&' + name + '=' + value;
      }
    } else {
      currentUrl += '?' + name + '=' + value;
    }
    if (window.location.href.split('#')[1]) {
      // window.location.href = currentUrl + '#' + window.location.href.split('#')[1];
      return currentUrl + '#' + window.location.href.split('#')[1];
    } else {
      // window.location.href = currentUrl;
      return currentUrl;
    }
  },
  refreshCurrentUrl: function refreshCurrentUrl() {
    var that = this;
    // 判断是否是ios微信浏览器(window.__wxjs_is_wkwebview是ios的独有方法)
    if (window.__wxjs_is_wkwebview === true) {
      // 从外链进来时，ios识别为支付url为当前地址，导致报错url未注册，需要刷新一遍才可以，所以这里在进入页面前强制刷新一次解决这个问题
      if (that.getUrlParams('papa') === 1) {
        return;
      }
      window.location.replace(that.addUrlPara('papa', 1));
    }
  },
  /* 手机号*/
  validateMobile: function validateMobile(str) {
    // const reg = /^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\d{8}$/
    var reg = /^1[0-9]\d{9}$/;
    return reg.test(str);
  }
};